import { graphql } from '@/gql/codegen/gql';

import { GET_COURSE_LESSON } from '@/routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/index.route.lazy';
import { useMutation } from '@apollo/client';
import { useCallback, useState } from 'react';

export const ANSWER_GOAL_SETTING_MUTAITON = graphql(/* GraphQL */ `
  mutation EmbaAnswerGoalSetting(
    $input: AnswerGoalSettingMutationInput!
  ) {
    embaAnswerGoalSetting(input: $input) {
      success
    }
  }
`);

export const useAnswerGoalSettingMutation = (
  embaUserAttendanceSlug: string,
  embaCourseLessonSlug: string,
) => {
  const [isAnsweredModalOpen, setIsAnsweredModalOpen] = useState(false);

  const [
    embaAnswerGoalSettingMutation,
    { error: answerGoalSettingError, loading: answerGoalSettingLoading },
  ] = useMutation(ANSWER_GOAL_SETTING_MUTAITON, {
    refetchQueries: [
      {
        query: GET_COURSE_LESSON,
        variables: {
          embaUserAttendanceSlug,
          embaCourseLessonSlug,
        },
      },
    ],
  });

  const answerGoalSetting = useCallback(
    async (content: string): Promise<void> => {
      await embaAnswerGoalSettingMutation({
        variables: {
          input: {
            embaUserAttendanceSlug,
            content,
            embaCourseLessonSlug,
          },
        },
      });
      setIsAnsweredModalOpen(true);
    },
    [
      embaAnswerGoalSettingMutation,
      embaUserAttendanceSlug,
      embaCourseLessonSlug,
    ],
  );

  const closeAnsweredModal = useCallback(() => {
    setIsAnsweredModalOpen(false);
  }, []);

  return {
    answerGoalSetting,
    answerGoalSettingError,
    answerGoalSettingLoading,
    isAnsweredModalOpen,
    closeAnsweredModal,
  };
};
